import {Button} from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import {useNavigate} from "react-router-dom"
import React from "react"

// back/accountBack come from the query string, so anyone can craft them. Only an
// app-relative path may be followed; anything else (javascript:, //host, absolute
// URLs) hides the button instead of navigating.
function safeBackURL(backURL?: string | null): string | null {
	if (!backURL || !backURL.startsWith("/") || backURL.startsWith("//") || backURL.startsWith("/\\")) {
		return null
	}
	try {
		const resolved = new URL(backURL, window.location.origin)
		return resolved.origin === window.location.origin ? backURL : null
	} catch {
		return null
	}
}

function BackToSearch({backURL}: {backURL?: string | null}): JSX.Element | null {
	const navigate = useNavigate()
	const safeURL = safeBackURL(backURL)
	if (safeURL) {
		return (
			<Button
				variant="text"
				size="small"
				style={{padding: 0}}
				startIcon={<ArrowBackIcon />}
				onClick={() => navigate(safeURL)}
			>
				Back
			</Button>
		)
	}

	return null
}

export {BackToSearch, safeBackURL}
